/** Supabase/PostgREST can reject with plain objects instead of Error instances. */
export function errorMessage(error: unknown): string {
  let message = '';
  if (error instanceof Error) message = error.message;
  else if (typeof error === 'string') message = error;
  else if (error && typeof error === 'object' && 'message' in error && typeof error.message === 'string') message = error.message;
  else if (error && typeof error === 'object' && 'error' in error && typeof error.error === 'string') message = error.error;
  return message.trim() || 'The operation failed without an error message.';
}
